/* Aroma Max — Subscribe & Save selector for the quick-view popup.
   The popup HTML is injected via AJAX, so inline scripts inside it do NOT run.
   We bind a single delegated 'change' listener at the document level instead. */
(function () {
  'use strict';

  function moneyFormat(cents) {
    var n = typeof cents === 'number' ? cents : parseInt(cents, 10);
    if (isNaN(n)) return '';
    var value = (n / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + parts.join('.');
  }

  function getPriceData(wrap) {
    var el = wrap.querySelector('[data-qv-plan-prices]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function currentVariantId(form) {
    var input = form.querySelector('input[name="id"]');
    return input ? String(input.value) : null;
  }

  function refresh(wrap) {
    var form = wrap.closest('form');
    if (!form) return;
    var note = wrap.querySelector('[data-qv-price-note]');
    var subRadio = wrap.querySelector('input[name="purchase_option"][value="subscription"]');
    var select = wrap.querySelector('[data-qv-plan-select]');
    var dynamic = form.querySelector('.m-product-dynamic-checkout');
    var isSub = subRadio && subRadio.checked;

    if (isSub) {
      if (select) { select.disabled = false; select.style.display = 'block'; }
      if (dynamic) dynamic.style.display = 'none';
      if (note && select) {
        var data = getPriceData(wrap);
        var vId = currentVariantId(form);
        var price = data && vId && data.variants[vId] ? data.variants[vId].plans[select.value] : undefined;
        note.textContent = (typeof price !== 'undefined')
          ? 'Subscription price: ' + moneyFormat(price) + ' per delivery · 20% off, cancel anytime'
          : '20% off · cancel anytime';
      }
    } else {
      if (select) { select.disabled = true; select.style.display = 'none'; }
      if (dynamic) dynamic.style.display = '';
      if (note) note.textContent = '';
    }
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var form = t.closest('form');
    if (!form) return;
    var wrap = form.querySelector('[data-qv-selling-plans]');
    if (!wrap) return;
    // Defer so the theme's variant picker updates the hidden variant id first.
    setTimeout(function () { refresh(wrap); }, 0);
  });
})();
